/**
 * Responsible for handling credit card icon displays of select inputs
 * as a jQuery plugin.
 * @module elements/fields/floatingLabelPlugin
 */
import $ from 'jquery';
import registerJQueryPlugin from '../../lib/register-jquery-plugin';

const displayCurrentCard = ($select, $ccIconHolder) => {
  const $selectedOption = $select.find('option:selected');
  const cardType = $selectedOption.data('cc-svg');
  const newClassList = [...$ccIconHolder[0].classList].map((classname) => {
    if (classname.includes('cc')) {
      return `icon--cc-${cardType}`;
    }
    return classname;
  });
  $ccIconHolder.attr('class', newClassList.join(' ')).html(`<svg><use xlink:href="#icon-cc-${cardType}"></use></svg>`);
};
const showCardInOptions = ($select) => {
  $select.find('option').each(function eachOptions() {
    const cardType = $(this).data('cc-name').toUpperCase();
    const optionWithCardType = `${cardType} * ${$(this).text().slice(-4)}`;
    if (!$(this).text().includes(cardType)) {
      $(this).text(optionWithCardType);
    }
  });
};
const clearCardInOptions = ($select) => {
  $select.find('option').each(function eachOptions() {
    $(this).text($(this).data('cc-number'));
  });
};
const storeNumbers = ($select) => {
  $select.find('option').each(function eachOptions() {
    $(this).attr('data-cc-number', $(this).text());
  });
};
const setupPlaceholder = ($wrap) => {
  $wrap.addClass('select-creditcard');
  $wrap.append('<div class="select-creditcard__holder"><span class="icon select-creditcard__icon icon--cc-generic"><svg><use xlink:href="#icon-cc-generic"></use></svg></span></div>');
  return $wrap.find('.select-creditcard__icon');
};
const setEventlisteners = ($select, $ccIconHolder) => {
  $select.on('change', () => {
    clearCardInOptions($select);
    displayCurrentCard($select, $ccIconHolder);
  });
  $select.on('focusout', () => {
    clearCardInOptions($select);
    displayCurrentCard($select, $ccIconHolder);
  });
  $select.on('mousedown', () => {
    showCardInOptions($select);
  });
  $select.on('mouseout', () => {
    clearCardInOptions($select);
  });
};
export default function selectCreditCard(el) {
  const $select = $(el);
  const $wrap = $select.closest('.floating-label');
  const $ccIconHolder = setupPlaceholder($wrap);
  storeNumbers($select);
  displayCurrentCard($select, $ccIconHolder);
  setEventlisteners($select, $ccIconHolder);
}

registerJQueryPlugin('selectCreditCard', selectCreditCard);



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/select-creditcard.js